import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <h1 className="text-3xl font-semibold tracking-tight">404</h1>
      <p className="text-sm text-slate-400">
        That route doesn't exist. Maybe you meant{" "}
        <Link to="/locations" className="text-emerald-400 hover:underline">
          /locations
        </Link>
        ?
      </p>
    </div>
  );
}
